import React from 'react';
import { GridPattern } from '../common/GridPattern';
import { CartesianAxes } from '../common/CartesianAxes';
import { DraggablePoint } from '../common/DraggablePoint';

export const ParabolaComponent = ({ params, showCoords, onPointDrag, svgRef, viewportWidth = 400, viewportHeight = 300, viewportScale = 1 }) => {
  const { vertexX = 200, vertexY = 200, a = 0.02, rangeStart = 50, rangeEnd = 350, stroke = "blue", strokeWidth = 3 } = params;
  
  const points = [];
  for (let x = rangeStart; x <= rangeEnd; x += 5) {
    const y = a * Math.pow((x - vertexX), 2) + vertexY;
    if (y >= 0 && y <= 300) {
      points.push(`${x},${y}`);
    }
  }
  
  const scaledWidth = viewportWidth * viewportScale;
  const scaledHeight = viewportHeight * viewportScale;
  const viewBox = `0 0 ${scaledWidth} ${scaledHeight}`;
  const displayHeight = Math.max(200, Math.min(800, viewportHeight * viewportScale));
  
  return (
    <svg ref={svgRef} viewBox={viewBox} className="w-full border border-gray-300" style={{ height: `${displayHeight}px` }}>
      <GridPattern viewportWidth={viewportWidth} viewportHeight={viewportHeight} viewportScale={viewportScale} />
      
      <polyline
        points={points.join(' ')}
        fill="none"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      
      {showCoords && (
        <DraggablePoint 
          cx={vertexX} cy={vertexY} 
          label="Vertex" coords={`(${vertexX},${vertexY})`}
          onDrag={(x, y) => onPointDrag('vertexX', x, 'vertexY', y)}
          svgRef={svgRef}
        />
      )}
      
      <CartesianAxes viewportWidth={viewportWidth} viewportHeight={viewportHeight} viewportScale={viewportScale} />
    </svg>
  );
};

